module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Delete ESG reports ","text":"Select 1 or more ESG reports to delete.  Please note that this cannot be undone.","cancel":"Cancel","delete":"Delete"},"de":{"title":"ESG-Berichte löschen ","text":"Wählen Sie 1 oder mehr ESG-Berichte zum Löschen aus. Bitte beachten Sie, dass dies nicht rückgängig gemacht werden kann.","cancel":"Abbrechen","delete":"Löschen"}}')
  delete Component.options._Ctor
}
